'use client';

import { faCalendarAlt } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import moment from 'moment';

import DetailsNav from '@/modules/league/details/components/DetailsNav';
import { DetailsHeaderData } from '@/modules/league/new-components/types';

interface SponsorsHeaderWrapperProps {
  header: DetailsHeaderData;
  params: { slug: string; sessionId: string };
  showSponsors: boolean;
}

export default function SponsorsHeaderWrapper({
  header,
  params,
  showSponsors,
}: SponsorsHeaderWrapperProps) {
  return (
    <div className='top-0 w-[100vw] -mx-4 sm:mx-auto sm:w-full sticky z-10 flex-col bg-white shadow-xs'>
      <div className='mx-auto flex max-w-[1400px] flex-col flex-wrap items-center gap-10 bg-white p-3 transition-all duration-300 sm:flex-row sm:flex-nowrap sm:gap-0 sm:p-4 sm:px-6'>
        <div className='flex flex-row items-center gap-4'>
          <div className='-mb-3 flex bg-white text-base font-semibold text-gray-900 sm:hidden sm:text-lg'>
            {header.details.Title}
          </div>
        </div>
        <div className='hidden w-full gap-4 sm:flex sm:w-1/2 lg:w-[70%]'>
          <img
            className='w-[140px] max-w-[45%] object-contain transition-all duration-300'
            src={header.details.ImageURL}
            alt={`${header.details.Title} logo`}
          />
          <div className='flex flex-col justify-center gap-2 transition-all duration-300'>
            <div className='hidden flex-row items-center text-lg font-semibold text-gray-900 sm:flex'>
              {header.details.Title}
            </div>
            <div className='flex flex-col items-center gap-4 lg:flex-row' />

            <div className='flex flex-row flex-wrap gap-2 text-sm sm:flex-nowrap'>
              <div>
                <span className='mr-2'>
                  <FontAwesomeIcon icon={faCalendarAlt} />
                </span>
                {`${moment.utc(header.session.MatchDateFirstDate).format('MMM DD, YYYY')} - ${moment
                  .utc(header.session.MatchDateLastDate)
                  .format('MMM DD, YYYY')}`}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='py-4 mx-4 overflow-x-scroll sm:overflow-hidden'>
        <DetailsNav
          leagueId={header.details.LeagueID}
          sessionId={header.session.LiveSession_LeagueSessionID}
          params={params}
          showSponsors={showSponsors}
        />
      </div>
    </div>
  );
}
